var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.625,
    viewBox: "0 0 18 17.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic-save",
    d: "M7.322,21.863A1.316,1.316,0,0,1,6,20.541V7.322A1.316,1.316,0,0,1,7.322,6H18.4l3.459,3.459v5.684l-6.7,6.72ZM8.49,11.64h7.887V8.49H8.49Zm5.442,7.469A2.29,2.29,0,0,0,15.551,15.2a2.29,2.29,0,1,0-3.239,3.239A2.207,2.207,0,0,0,13.931,19.109Zm2.424,4.517v-1.1L21.378,17.5l1.1,1.1-5.023,5.023Zm6.7-5.6-1.1-1.1.859-.859a.269.269,0,0,1,.463,0l.595.595a.353.353,0,0,1,0,.551Z",
    transform: "translate(-6 -6)",
    fill: "#f26122"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSave);
export default __webpack_public_path__ + "static/media/ic-save.a2b4a85c.svg";
export { ForwardRef as ReactComponent };